import React from 'react'
import clsx from 'clsx'
import { FlexProps } from './Flex.types'
import styles from './Flex.module.scss'

const Flex: React.FC<FlexProps> = ({
  children,
  className,
  inline = false,
  direction = 'row',
  justifyContent,
  alignItems,
  wrap,
  gap,
  style,
  fullWidth = false,
  ...rest
}) => {
  // Early return if no children
  if (!children) return null

  return (
    <div
      style={{ ...style, gap }}
      className={clsx(
        styles.flex,
        inline && styles.inline,
        styles[
          `direction${direction.charAt(0).toUpperCase() + direction.slice(1)}`
        ],
        justifyContent &&
          styles[
            `justify${justifyContent.charAt(0).toUpperCase() + justifyContent.slice(1)}`
          ],
        alignItems &&
          styles[
            `align${alignItems.charAt(0).toUpperCase() + alignItems.slice(1)}`
          ],
        wrap && styles.wrap,
        fullWidth && styles.fullWidth,
        className
      )}
      {...rest}
    >
      {children}
    </div>
  )
}

export default Flex
